import { type TreeDataOption } from '@framework/ui/components/input/TreeSelectInput.tsx';
import { type INestedScope } from './getIndentScopes.ts';

/**
 * Normalizza la struttura ad albero degli ambiti.
 */
export function normalizeScopesTreeData(
  scope: INestedScope[],
): TreeDataOption[] {
  return scope.map(s => {
    return {
      title: s.etichetta!,
      value: s.id!,
      label: s.etichetta!,
      children: s.children ? normalizeScopesTreeData(s.children) : undefined,
    };
  });
}
